module.exports = __webpack_public_path__ + "img/conveyor-belt-boxes.27683927.svg";